import { Icons } from "../../assets/icons";
import { theme, Typography } from "antd";

function SectionTwo() {
  return (
    <section className="mx-auto mb-12 w-full max-w-[1920px]">
      {/* First Counters Row */}
      <div className="flex flex-wrap justify-around px-10 py-7">
        {/* OCEAN IV COUNTER */}
        <CounterBox
          icon={<Icons.OcenaIvCounterIcon width={90} height={90} />}
          title="OCEAN IV"
          text="Total Psychosocial Risk Assessments assigned to your company"
          countValue="10"
          counterBoxBg="#0e3746"
        />
        {/* PROGRAM COUNTER */}
        <CounterBox
          icon={<Icons.ProgramCounterIcon width={90} height={90} />}
          title="PROGRAM"
          text="Total programs created and assigned to your company"
          countValue="10"
          counterBoxBg="#15607b"
        />
        {/* UPDATES COUNTER */}
        <CounterBox
          icon={<Icons.UpdatesCounterIcon width={90} height={90} />}
          title="UPDATES"
          text="Total updates sent to your company"
          countValue="4"
          counterBoxBg="#979b98"
        />
      </div>
      {/* Second Row Counters Row */}
      <div className="flex flex-wrap justify-around px-10 py-7">
        {/* SURVEYS COUNTER */}
        <CounterBox
          icon={<Icons.SurveysCounterIcon width={90} height={90} />}
          title="SURVEYS"
          text="Total surveys sent to your employees"
          countValue="10"
          counterBoxBg="#8a9ca0"
        />
        {/* EVENTS COUNTER */}
        <CounterBox
          icon={<Icons.EventsCounterIcon width={90} height={90} />}
          title="EVENTS"
          text="Total events sent to your employees"
          countValue="10"
          counterBoxBg="#dec8b5"
        />

        {/* REWARDS COUNTER */}
        <CounterBox
          icon={<Icons.RewardsCounterIcon width={90} height={90} />}
          title="REWARDS"
          text="Total rewards sent to your employees"
          countValue="4"
          counterBoxBg="#a8abc8"
        />
      </div>
    </section>
  );
}

export default SectionTwo;

// CounterBox Component

export interface CounterBoxProps {
  readonly icon: React.ReactNode;
  readonly title: string;
  readonly text: string;
  readonly countValue: string;
  readonly counterBoxBg: string;
}

export function CounterBox(props: CounterBoxProps) {
  const { token } = theme.useToken();

  return (
    <article
      className="border-3 inset-shadow-sm flex basis-[30%] rounded-md p-4 shadow-xl shadow-slate-400/50"
      style={{ backgroundColor: props.counterBoxBg }}
    >
      {/* Left Side */}
      <div className="flex flex-1 flex-col items-center">
        <div>{props.icon}</div>
        <Typography.Title
          level={2}
          className="m-0 text-center text-3xl tracking-tight text-white"
          style={{
            fontFamily: token.fontFamily,
          }}
        >
          {props.title}
        </Typography.Title>
        <Typography.Paragraph
          className="text-large w-52 text-center text-lg tracking-wide text-white"
          style={{ fontFamily: token.fontFamily }}
        >
          {props.text}
        </Typography.Paragraph>
      </div>
      {/* Right Side */}
      <div className="flex flex-1 items-center justify-center">
        <div className="flex h-20 w-20 items-center justify-center rounded-full bg-[#cca881] text-4xl font-extrabold text-white">
          {props.countValue}
        </div>
      </div>
    </article>
  );
}
